<nz-select
  [formControl]="control"
  [nzAllowClear]="allowClear"
  [nzPlaceHolder]="getPlaceholder()"
  [nzShowSearch]="showSearch"
  [nzDropdownClassName]="dropdownClassName"
  [class]="class"
  [nzMode]="mode"
  [nzMaxTagCount]="maxTagCount"
  [class.error]="
    (this.isFormSubmitted || this.control?.touched) && this.control?.errors
  "
>
  @for (item of items; track $index) {
    <nz-option
      [nzValue]="item?.[valueKey]"
      [nzLabel]="item?.[labelKey]"
    ></nz-option>
  }
</nz-select>
